import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormRegisterEmailComponent } from '@app/core/user/components/form-register-email/form-register-email.component';
import { FormRegisterValidationComponent } from '@app/core/user/components/form-register-validation/form-register-validation.component';
import { RegisterComponent } from '@app/core/user/components/register/register.component';

import { SharedModule } from '@app/shared/shared.module';
import { FacebookConnectModule } from '@app/core/user/components/facebook-connect/facebook-connect.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, FacebookConnectModule],
  declarations: [RegisterComponent, FormRegisterValidationComponent, FormRegisterEmailComponent],
  exports: [RegisterComponent],
  entryComponents: [RegisterComponent]
})
export class RegisterModule {}
